module.exports = __webpack_public_path__ + "static/img/docs.20eecda0.png";